/**
 * Application constants matching Flutter app configuration
 * 
 * Note: For environment-specific values (CDN URLs, bucket names, etc.)
 * use config/env.ts instead
 */
export const APP_VERSIONING = {
  APP_NAME: 'Expause',
  APP_VERSION: '0.0.1',
} as const;

export type AppVersioning = typeof APP_VERSIONING;
